import { useLocation, useNavigate } from "react-router-dom";
import "./causeDetails.css";
import {
  adminCauseAction,
  donationlist,
  donationtransfer,
} from "../../services/mainService";
import { useEffect, useState } from "react";
import { Snackbar } from "../../utils/snackbar";

const CauseDetails = () => {
  const [donations, setDonations] = useState();
  const [pagination, setpagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const { state } = useLocation();
  const cause = state;
  const navigate = useNavigate();

  useEffect(() => {
    fetchdonation();
  }, []);

  const fetchdonation = async () => {
    try {
      if (cause.status === "Approved") return;
      const res = await donationlist({
        page: pagination.current_page,
        cause_id: cause.id,
      });

      setDonations(res.data);
      setpagination(res.pagination_info);
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };
  const handledonationtransfer = async () => {
    try {
      const res = await donationtransfer({
        cause_id: cause.id,
      });
      setSnackbar({
        msg: res.message,
        severity: "success",
        open: true,
      });
      navigate("/finishedcause");
    } catch (err) {
      console.error("Error fetching causes:", err);
    } finally {
    }
  };

  if (!cause) return <div>No Data Found</div>;

  const percentage = (cause.amount_collected / cause.amount_required) * 100;

  const publishCause = async () => {
    if (!startDate || !endDate) {
      alert("Please select start and end date");
      return;
    }

    try {
      setLoading(true);

      const params = {
        cause_id: cause.id,
        status: 1,
        start_date: startDate,
        end_date: endDate,
      };

      const res = await adminCauseAction(params);
      console.log(res);
      setSnackbar({
        msg: res.message || "Cause published successfully",
        severity: "success",
        open: true,
      });
      navigate("/Publishedcause");
    } catch (err) {
      console.error(err);
      setSnackbar({
        msg: err.response?.data?.msg || "Failed to publish cause ",
        severity: "error",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };
  const rejectCause = async () => {
    try {
      setLoading(true);

      const params = {
        cause_id: cause.id,
        status: 2,
      };
      const res = await adminCauseAction(params);
      console.log(res);
      setSnackbar({
        msg: res.message || "Cause rejected successfully",
        severity: "success",
        open: true,
      });
      navigate("/allcauses");
    } catch (err) {
      console.error(err);
      setSnackbar({
        msg: err.response?.data?.msg || "Failed to reject cause ",
        severity: "error",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cause-details-wrapper">
      <div className="cause-details-container">
        {/* LEFT SECTION */}
        <div className="cause-main">
          <img src={cause.image} alt={cause.title} className="cause-image" />

          <h2>{cause.title}</h2>
          <p className="cause-summary">{cause.summary}</p>

          <div className="progress-section">
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${percentage}%` }}
              />
            </div>
            <div className="progress-info">
              <span>₹ {cause.amount_collected}</span>
              <span>of ₹ {cause.amount_required}</span>
            </div>
          </div>

          <p className="cause-description">{cause.description}</p>

          <div className="location-info">
            📍 {cause.address}, {cause.district}, {cause.state} -{" "}
            {cause.pincode}
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="cause-sidebar">
          <div className="card">
            <h3>Beneficiary Details</h3>
            <p>
              <strong>Name:</strong> {cause.fullname}
            </p>
            <p>
              <strong>Gender:</strong> {cause.gender}
            </p>
            <p>
              <strong>DOB:</strong> {cause.dob}
            </p>
            <p>
              <strong>Category:</strong> {cause.category}
            </p>
            <p>
              <strong>Beneficiary Orphan:</strong> {cause.benificiary_orphan}
            </p>
          </div>

          <div className="card">
            <h3>Bank Details</h3>
            <p>
              <strong>Account Holder:</strong> {cause.account_holder_name}
            </p>
            <p>
              <strong>Bank:</strong> {cause.bank_name}
            </p>
            <p>
              <strong>Account No:</strong> {cause.account_number}
            </p>
            <p>
              <strong>IFSC:</strong> {cause.ifsc_code}
            </p>
            <p>
              <a
                href={cause.bank_document_image_name}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
              >
                View Bank Document
              </a>
            </p>
            <p>
              <a
                href={cause.pan_card_image}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
              >
                Pancard
              </a>
            </p>
            <p>
              <a
                href={cause.aadhar_card_image}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
              >
                Aadhar Card
              </a>
            </p>
            <p>
              <a
                href={cause.image}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
              >
                Situation
              </a>
            </p>
            <p>
              <a
                href={cause.pdf}
                target="_blank"
                rel="noreferrer"
                className="doc-link"
              >
                Proof Document
              </a>
            </p>
          </div>
          {cause.status === "Approved" ? (
            <div className="publish-section">
              <div className="date-field">
                <label>Start Date</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>

              <div className="date-field">
                <label>End Date</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>

              <button
                className="transfer-btn"
                onClick={publishCause}
                disabled={loading}
              >
                {loading ? "Publishing..." : "Publish Cause"}
              </button>
              <button
                className="reject-btn"
                onClick={rejectCause}
                disabled={loading}
              >
                Rejected
              </button>
            </div>
          ) : cause.bank_transfer_status === "Pending" ? (
            <button className="transfer-btn" onClick={handledonationtransfer}>
              Mark as Transfer Complete
            </button>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* DONATION LIST */}
      {donations?.length > 0 && (
        <div className="donation-section">
          <h3>Donation List</h3>

          <table className="donation-table">
            <thead>
              <tr>
                <th>Donor</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {donations.map((donation) => (
                <tr key={donation.id}>
                  <td>{donation.fullname}</td>
                  <td>{donation.donation_type}</td>
                  <td>₹ {donation.donation_amount}</td>
                  <td>{donation.phone_number}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Snackbar
        open={snackbar.open}
        message={snackbar.msg}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </div>
  );
};

export default CauseDetails;
